import React from 'react';
import { DivStyles, DateStyles } from './date-cell-styles';
var compareDates = function (date1, date2) {
    var d1 = '' + date1.getDate() + date1.getMonth() + date1.getFullYear();
    var d2 = '' + (date2 === null || date2 === void 0 ? void 0 : date2.getDate()) + (date2 === null || date2 === void 0 ? void 0 : date2.getMonth()) + (date2 === null || date2 === void 0 ? void 0 : date2.getFullYear());
    return d1 === d2;
};
var DateCell = function (_a) {
    var date = _a.date, state = _a.state, handleMouseEnter = _a.handleMouseEnter, handleMouseLeave = _a.handleMouseLeave;
    return (React.createElement(DivStyles, { startDate: compareDates(date, state.startDate), endDate: compareDates(date, state.endDate), onMouseEnter: function () { return handleMouseEnter(date); }, onMouseLeave: function () { return handleMouseLeave(); } },
        React.createElement(DateStyles, { startEndDate: compareDates(date, state.startDate) || compareDates(date, state.endDate) }, date.getDate())));
};
export default DateCell;
